import React from "react"
import { observer } from "mobx-react-lite"
import { useLocation } from "react-router-dom"

import Templates from "@components/ui/Templates"
import SidebarPopup from "@components/modals/components/SidebarPopup"

import DataSourceHeader from "../KnowledgeSource/DataSourceHeader"
import ActiveAvatarContextProvider from "../ActiveAvatarContext"
import EmailsCollection from "./EmailsCollection"
import Email from "./Email"

import styles from "./Sidebar.module.sass"

export interface EmailsSidebarProps {
  open: boolean
  onClose?: () => void
}

export const EmailsSidebar: React.FC<EmailsSidebarProps> = observer(
  ({ open = false, onClose }) => {
    const location = useLocation()

    return (
      <ActiveAvatarContextProvider avatarId={location.state?.avatar}>
        <SidebarPopup open={open} onClose={onClose}>
          <Templates.RollScript
            className={styles.root}
            headerSocket={
              <DataSourceHeader title="Emails" chips={defaultChips} />
            }
          >
            <div className={styles.body}>
              <EmailsCollection />
              <Email />
            </div>
          </Templates.RollScript>
        </SidebarPopup>
      </ActiveAvatarContextProvider>
    )
  }
)

export default EmailsSidebar

const defaultChips = ["Informal Knowledge"]
